import { isExternalUrl } from './external-url';

const LEGACY_HELIX_BASE_PATH_PATTERN = /^\/helix(?=\/|[?#]|$)/;

export function isUrlWithBase(url: string, baseUrl: string) {
  const appRouteUrl = url;

  return !baseUrl || appRouteUrl.startsWith(baseUrl);
}

export function prependUrl(url: string) {
  return url.startsWith('/') ? url : `/${url}`;
}

function normalizeLegacyHelixBasePath(url: string, baseUrl: string) {
  if (baseUrl !== '/' || !LEGACY_HELIX_BASE_PATH_PATTERN.test(url)) {
    return url;
  }

  return prependUrl(url.replace(LEGACY_HELIX_BASE_PATH_PATTERN, ''));
}

export function hGetAppRouteUrl(url: string, baseUrl: string, noRoute: boolean) {
  const appRouteUrl = normalizeLegacyHelixBasePath(url, baseUrl);

  if (noRoute) {
    if (isUrlWithBase(appRouteUrl, baseUrl)) {
      return prependUrl(appRouteUrl.replace(baseUrl, ''));
    } else {
      if (isExternalUrl(appRouteUrl)) {
        return appRouteUrl;
      } else {
        return window.location.origin + prependUrl(appRouteUrl);
      }
    }
  } else {
    return appRouteUrl;
  }
}
